import React from 'react';
import { Link as RouterLink } from 'react-router-dom';
import uniqid from 'uniqid';

import { CONTENT_TYPES } from './content-types.constants';

interface RelatedContentItemAttributes {
  name?: string;
  contentIs?: string;
}

interface RelatedContentItem {
  id: string | number;
  attributes?: RelatedContentItemAttributes;
}

interface RelatedContentProps {
  content?: RelatedContentItem[];
}

const RelatedContent = ({ content = [] }: RelatedContentProps): React.JSX.Element => {
  const getIcon = (contentType?: string): React.ReactNode => {
    const item = CONTENT_TYPES.find(({ type }) => type === contentType);

    return item?.icon;
  };

  return (
    <div className="mobile:mb-6 xs:mb-8">
      <h2 className="font-semibold text-xl">Related content</h2>
      {content.map(({ id, attributes = {} }) => {
        const { name, contentIs } = attributes;

        return (
          <div key={uniqid()} className="mt-3">
            <RouterLink
              to={`/learn/content/${(contentIs as string).toLowerCase()}s/${id}`}
              className="text-blue-700 hover:text-navy-800 font-medium text-lg transition"
            >
              {name}
            </RouterLink>
            <div className="flex items-center text-sm text-gray-400">
              <div className="flex items-center">{getIcon(contentIs)}</div>
              <div className="ml-2 text-sm">{contentIs}</div>
            </div>
          </div>
        );
      })}
    </div>
  );
};

export default RelatedContent;
